import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'

export const TransitionalPlusMinusIcon: FunctionComponent<PlusMinusIconProps> = ({
  toggle = false,
  className,
  fill,
  width = 32,
  height = 32,
  customColour,
  ...rest
}) => {
  return (
    <>
      <Icon
        aria-hidden={false}
        aria-label={toggle ? 'minus' : 'plus'}
        className={className}
        data-testid="icon-plusminus"
        fill={fill}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        width={width}
        {...rest}
      >
        {!toggle && (
          <rect
            data-testid="icon-plusminus-vertical"
            fill={customColour}
            height="16"
            width="2"
            x="7"
          />
        )}

        <rect
          data-testid="icon-plusminus-horizontal"
          fill={customColour}
          height="2"
          width="16"
          y="7"
        />
      </Icon>
    </>
  )
}

///////// IMPLEMENTATION /////////

export type PlusMinusIconProps = IconProps & {
  toggle?: boolean
}
